import DefaultLayout from '@/Layouts/DefaultLayout';
import { lazy } from 'react';
// import { FeatureRoutes } from '$/feature/routes/routes';
import { LoginRoutes } from '@/features/auth/routes/routes';
import { AuthInitializer } from '@/features/auth/guard/authInitializer';
import { CarRoutes } from '@/features/car/routes/routes';
import { MaintenanceRoutes } from '@/features/maintenance/routes/routes';
import { BranchesRoutes } from '@/features/branch/routes/routes';
import { HumanResourcesRoutes } from '@/features/humanResources/routes/routes';
import { CustomerRealtionsRoutes } from '@/features/customerRelations/routes/routes';
import { SelfServicesRoutes } from '@/features/selfServices/routes/routes';
import { InvoicingRoutes } from '@/features/invoicing/routes/routes';
import { BookingRoutes } from '@/features/booking/routes/routes';
import { HrSelfServicesRoutes } from '@/features/hrSelfServices/routes/routes';
import { InsuranceRoutes } from '@/features/Insurance/routes/routes';
import { FinancesRoutes } from '@/features/finances/routes/routes';
import { PayrollRoutes } from '@/features/payroll-allowances/routes/routes';
import { TraineesRoutes } from '@/features/trainees/routes/routes';
import { CareerPathRoutes } from '@/features/careerPath/routes/routes';
import { ProgramsRoutes } from '@/features/programs/routes/routes';
import { EntryExitRoutes } from '@/features/entry-and-exit/routes/routes';
import { TasksRoutes } from '@/features/tasks/routes/routes';
import { AccessControlRoutes } from '@/features/accessControl/routes/routes';

// ----------------------------------------------------------------------

const Home = lazy(() => import('@/core/global-pages/Home'));
const SoonPage = lazy(() => import('@/core/global-pages/SoonPage'));

// ----------------------------------------------------------------------

const routes = [
    {
        path: '/',
        element: (
            <AuthInitializer>
                <DefaultLayout />
            </AuthInitializer>
        ),
        children: [
            { index: true, element: <Home /> },
            {
                path: '/coming-soon',
                element: <SoonPage />,
                layout: 'default',
                isAuthReq: true,
            },
            // ...FeatureRoutes,
            ...CarRoutes,
            ...BranchesRoutes,
            ...CustomerRealtionsRoutes,
            ...MaintenanceRoutes,
            ...HumanResourcesRoutes,
            ...SelfServicesRoutes,
            ...InvoicingRoutes,
            ...BookingRoutes,
            ...InsuranceRoutes,
            ...FinancesRoutes,
            ...PayrollRoutes,
            ...TraineesRoutes,
            ...CareerPathRoutes,
            ...ProgramsRoutes,
            ...EntryExitRoutes,
            ...TasksRoutes, 
            ...HrSelfServicesRoutes, // Assuming HrSelfServicesRoutes is defined in the same way as others
            ...AccessControlRoutes,
        ],
    },
    ...LoginRoutes,
];
export { routes };
